module.exports = __webpack_public_path__ + "static/suedamerika-4ae719ee358cceecef6a3928130d880a.svg";